import { gtagEnvelope } from './gtagEnvelope';

export const trackBlur = (id: string, type?: string) => {
  const fieldId = id || type;
  gtagEnvelope('event', 'form_field_focus', {
    form_field: `form-field_${fieldId}`,
    form_field_url: `${window.location.pathname}`,
  });
};
